import React from 'react';
import { format, formatDistanceToNow } from 'date-fns';
import { Activity, ActivityAction } from '../types';
import {
  ActivityItemWrapper,
  ActivityHeader,
  ActivityTitle,
  ActivityTimestamp,
  ActivityDescription,
  ActivityMetadata,
  ActivityStatusBadge,
} from '../styles/styled';
import { COLORS } from '../styles/constants';

interface ActivityItemProps {
  activity: Activity;
  onClick: (activity: Activity) => void;
  onEmailPreview?: (
    emailContent: NonNullable<Activity['emailContent']>
  ) => void;
}

const getActionColor = (action: ActivityAction) => {
  switch (action) {
    case 'Created':
    case 'Added':
      return COLORS.SUCCESS;
    case 'Deleted':
    case 'Removed':
      return COLORS.ERROR;
    case 'Modified':
      return COLORS.WARNING;
    case 'Opened':
      return COLORS.PRIMARY;
    default:
      return COLORS.SECONDARY;
  }
};

const formatTimestamp = (timestamp: string) => {
  const date = new Date(timestamp);
  return {
    distance: formatDistanceToNow(date, { addSuffix: true }),
    fullDate: format(date, 'MMM dd, yyyy HH:mm'),
  };
};

export const ActivityItem: React.FC<ActivityItemProps> = ({
  activity,
  onClick,
}) => {
  const { fullDate } = formatTimestamp(activity.timestamp);

  return (
    <ActivityItemWrapper onClick={() => onClick(activity)}>
      <ActivityHeader>
        <ActivityTitle>
          {activity.action === 'Created'
            ? 'Created'
            : activity.action === 'Deleted'
            ? 'Deleted'
            : activity.action === 'Modified'
            ? 'Modified'
            : activity.action === 'Removed'
            ? 'Removed'
            : activity.action === 'Added'
            ? 'Added'
            : activity.action === 'Opened'
            ? 'Opened'
            : activity.action}
        </ActivityTitle>
        <ActivityTimestamp title={fullDate}>{fullDate}</ActivityTimestamp>
      </ActivityHeader>
      <ActivityDescription>{activity.details}</ActivityDescription>
      <ActivityMetadata>
        <span>
          By: {activity.originalUserDisplayName || activity.displayName}{' '}
          {activity.originalUserDisplayName &&
            `on behalf of ${activity.displayName}`}
        </span>
        {activity.workflowId && <span>Workflow ID: {activity.workflowId}</span>}
      </ActivityMetadata>
      <ActivityStatusBadge
        $status="completed"
        $color={getActionColor(activity.action)}
      >
        {activity.action}
      </ActivityStatusBadge>
    </ActivityItemWrapper>
  );
};
